import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import TransactionLogList from '../../modules/admin/components/TransactionLogList';

const TransactionLog = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('admin->>TransactionLog.Transaction Log')} />

      <TransactionLogList />
    </>
  );
};

export default TransactionLog;
